import PropTypes from 'prop-types';
import React from 'react';
import Loader from '../Loader/Loader';
import InfiniteScroll from '../utils/InfiniteScroll';
import scrollIntoView from '../utils/scrollIntoView';
import { DATA_HOOKS, DATA_OPTION, DATA_SHOWN, DATA_DIRECTION, DROPDOWN_LAYOUT_DIRECTIONS, OPTION_DATA_HOOKS, DROPDOWN_LAYOUT_LOADER, DATA_SELECTED_OPTION_ID, } from './DataAttr';
import { st, classes } from './WsrDropdownLayout.st.css';
import { filterObject } from '../utils/filterObject';
import ReactDOM from 'react-dom';
import { listItemSectionBuilder } from '../ListItemSection';
import { listItemSelectBuilder } from '../ListItemSelect';
import { listItemActionBuilder } from '../ListItemAction';
import { isString } from '../utils/StringUtils';
const byId = (id) => (option) => option.id === id;
const MOUSE_EVENTS_SUPPORTED = ['mouseup', 'touchend'];
const KEY = {
    arrowLeft: 'ArrowLeft',
    arrowUp: 'ArrowUp',
    arrowRight: 'ArrowRight',
    arrowDown: 'ArrowDown',
    escape: 'Escape',
    tab: 'Tab',
    enter: 'Enter',
    space: ' ',
    home: 'Home',
    end: 'End',
};
const ListTypeEnum = {
    action: 'action',
    select: 'select',
};
const modulu = (n, m) => {
    const remain = n % m;
    return remain >= 0 ? remain : remain + m;
};
const getUnit = (value) => isString(value) ? value : `${value}px`;
const NOT_HOVERED_INDEX = -1;
export const DIVIDER_OPTION_VALUE = '-';
class DropdownLayout extends React.PureComponent {
    constructor(props) {
        super(props);
        this.focusableItemsIdsList = [];
        this.savedOnClicks = [];
        this.children = {};
        this.containerRef = React.createRef();
        // Deprecated
        this._onMouseEventsHandler = (e) => {
            if (!this._checkIfEventOnElements(e, [ReactDOM.findDOMNode(this)])) {
                this._onClickOutside(e);
            }
        };
        this._onClickOutside = (event) => {
            const { visible, onClickOutside } = this.props;
            if (visible && onClickOutside) {
                onClickOutside(event);
            }
        };
        this._onSelect = (index, e) => {
            const { options, onSelect, listType } = this.props;
            if (listType !== ListTypeEnum.select) {
                e.stopPropagation();
                this._onClose();
                return undefined;
            }
            const chosenOption = options[index];
            if (chosenOption) {
                const sameOptionWasPicked = chosenOption.id === this.state.selectedId;
                if (onSelect) {
                    e.stopPropagation();
                    onSelect(chosenOption, sameOptionWasPicked);
                }
            }
            if (!this._isControlled()) {
                this.setState({ selectedId: chosenOption && chosenOption.id });
            }
            return !!onSelect && chosenOption;
        };
        this._onActionClick = (e) => {
            const onClick = this.savedOnClicks.find(({ id }) => id === e.id).onClick;
            onClick && onClick(e);
        };
        this._saveOnClicks = () => {
            this.savedOnClicks = this.props.options.map(({ id, onClick }) => ({
                id,
                onClick,
            }));
        };
        this._onMouseEnter = (index) => {
            if (this._isSelectableOption(this.props.options[index])) {
                this._markOption(index);
            }
        };
        this._onMouseLeave = () => this._markOption(NOT_HOVERED_INDEX);
        /**
         * persist hover index & invoke callback from props;
         * scroll element at index into view;
         */ this._markOptionAndScrollIntoViewOnMoundAndChange = () => {
            const { focusOnOption, options } = this.props;
            const markedIndex = options.findIndex(byId(focusOnOption));
            if (markedIndex !== NOT_HOVERED_INDEX) {
                this._markOptionAndScrollIntoView(markedIndex);
            }
            else {
                // clear hoverIndex state => remove hover style
                this._markOption(NOT_HOVERED_INDEX);
            }
        };
        /**
         * persist hover index & invoke callback from props;
         * scroll element at index into view;
         */
        this._markOptionAndScrollIntoView = (markedIndex) => {
            const { infiniteScroll } = this.props;
            this._markOption(markedIndex);
            const menuElement = this.options;
            const hoveredElement = (infiniteScroll
                ? this.options.childNodes[0].childNodes[markedIndex]
                : this.options.childNodes[markedIndex]);
            scrollIntoView(menuElement, hoveredElement);
        };
        /**
         * Handle keydown events for the DropdownLayout, mostly for accessibility
         *
         * @param {SyntheticEvent} event - The keydown event triggered by React
         * @returns {boolean} - Whether the event was handled by the component
         */
        this._onSelectListKeyDown = (event) => {
            if (!this.props.visible ||
                this.props.isComposing ||
                this.props.listType !== ListTypeEnum.select) {
                return false;
            }
            switch (event.key) {
                case KEY.arrowDown: {
                    this._markNextStep(1);
                    event.preventDefault();
                    break;
                }
                case KEY.arrowUp: {
                    this._markNextStep(-1);
                    event.preventDefault();
                    break;
                }
                case KEY.space:
                case KEY.enter: {
                    const indexToSelect = this.props.options.findIndex(byId(this.state.focusedItemId));
                    if (!this._onSelect(indexToSelect, event)) {
                        return false;
                    }
                    break;
                }
                case KEY.tab: {
                    const indexToSelect = this.props.options.findIndex(byId(this.state.focusedItemId));
                    if (this.props.closeOnSelect) {
                        return this._onSelect(indexToSelect, event);
                    }
                    else {
                        if (this._onSelect(indexToSelect, event)) {
                            event.preventDefault();
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                }
                case KEY.escape: {
                    this._onClose();
                    break;
                }
                default: {
                    return false;
                }
            }
            event.stopPropagation();
            return true;
        };
        this._focus = (focusedItemId, e) => {
            e && e.preventDefault();
            const element = this.children[focusedItemId];
            if (!element) {
                this.setState({ focusedItemId });
                return;
            }
            const native = element.focus;
            const focusableHOC = element.wrappedComponentRef;
            const callback = native
                ? element.focus
                : focusableHOC
                    ? focusableHOC.innerComponentRef.focus
                    : () => ({});
            this.setState({ focusedItemId }, () => callback());
        };
        this._handleActionListNavigation = (event, id) => {
            const length = this.focusableItemsIdsList.length;
            let focusedItemId = this.state.focusedItemId;
            const { key } = event;
            const currentMenuItemIndex = this.focusableItemsIdsList.indexOf(id);
            const firstMenuItem = this.focusableItemsIdsList[0];
            const lastMenuItem = this.focusableItemsIdsList[length - 1];
            if (key === KEY.arrowLeft || key === KEY.arrowUp) {
                focusedItemId =
                    id === 0
                        ? lastMenuItem
                        : this.focusableItemsIdsList[currentMenuItemIndex - 1];
            }
            if (key === KEY.arrowRight || key === KEY.arrowDown) {
                focusedItemId =
                    currentMenuItemIndex === length - 1
                        ? firstMenuItem
                        : this.focusableItemsIdsList[currentMenuItemIndex + 1];
            }
            if (key === KEY.home) {
                focusedItemId = firstMenuItem;
            }
            if (key === KEY.end) {
                focusedItemId = lastMenuItem;
            }
            if (focusedItemId !== this.state.focusedItemId) {
                this._focus(focusedItemId, event);
            }
        };
        this._onActionListKeyDown = (event, id) => {
            if (this.props.listType !== ListTypeEnum.action) {
                return;
            }
            const { key } = event;
            if (key === KEY.space || key === KEY.enter) {
                event.preventDefault();
                this._onActionClick({ id: this.state.focusedItemId });
                this._onClose();
            }
            else if (key === KEY.escape || key === KEY.tab) {
                this._onClose();
            }
            else {
                this._handleActionListNavigation(event, id);
            }
            event.stopPropagation();
        };
        this._onClose = () => {
            this._markOption(NOT_HOVERED_INDEX);
            if (this.props.onClose) {
                this.props.onClose();
            }
        };
        this._wrapWithInfiniteScroll = (scrollableElement) => {
            if (!this.options) {
                this.loadedWithUndefinedOptions = true;
            }
            return (React.createElement(InfiniteScroll, { useWindow: true, dataHook: DATA_HOOKS.INFINITE_SCROLL_CONTAINER, scrollElement: this.options, loadMore: this.props.loadMore, hasMore: this.props.hasMore, data: this.props.options, loader: React.createElement("div", { className: classes.loader },
                    React.createElement(Loader, { dataHook: DROPDOWN_LAYOUT_LOADER, size: "small" })) }, scrollableElement));
        };
        /** for testing purposes only */
        this._getDataAttributes = () => {
            const { visible, dropDirectionUp } = this.props;
            const { selectedId } = this.state;
            return filterObject({
                'data-hook': DATA_HOOKS.CONTENT_CONTAINER,
                [DATA_SHOWN]: visible,
                [DATA_SELECTED_OPTION_ID]: selectedId === 0 ? `${selectedId}` : selectedId,
                [DATA_DIRECTION]: dropDirectionUp
                    ? DROPDOWN_LAYOUT_DIRECTIONS.UP
                    : DROPDOWN_LAYOUT_DIRECTIONS.DOWN,
            }, (_key, value) => !!value);
        };
        // For testing purposes only
        this._getItemDataAttr = ({ focused, hovered, selected, disabled }) => {
            const { itemHeight, selectedHighlight } = this.props;
            return filterObject({
                [DATA_OPTION.DISABLED]: disabled,
                [DATA_OPTION.SELECTED]: selected && selectedHighlight,
                [DATA_OPTION.FOCUSED]: focused,
                [DATA_OPTION.HOVERED]: hovered,
                /* deprecated */
                [DATA_OPTION.SIZE]: itemHeight,
            }, (_key, value) => !!value);
        };
        this.state = {
            hoveredIndex: NOT_HOVERED_INDEX,
            selectedId: props.selectedId,
            focusedItemId: props.selectedId ?? DropdownLayout.NONE_SELECTED_ID,
        };
    }
    componentDidMount() {
        if (this.loadedWithUndefinedOptions && this.options) {
            this.forceUpdate();
        }
        const { focusOnSelectedOption, scrollToOption, autoFocus } = this.props;
        if (focusOnSelectedOption) {
            this._scrollToSelectedOption();
        }
        else if (this.props.focusOnOption) {
            this._markOptionAndScrollIntoViewOnMoundAndChange();
        }
        if (scrollToOption) {
            this._scrollToOption();
        }
        this._markOptionByProperty(this.props);
        // Deprecated
        MOUSE_EVENTS_SUPPORTED.forEach((eventName) => {
            document.addEventListener(eventName, this._onMouseEventsHandler, true);
        });
        this._boundEvents = MOUSE_EVENTS_SUPPORTED;
        if (autoFocus) {
            this._focusFirstOption();
        }
    }
    componentWillUnmount() {
        if (this._boundEvents && typeof document !== 'undefined') {
            this._boundEvents.forEach((eventName) => {
                document.removeEventListener(eventName, this._onMouseEventsHandler, true);
            });
        }
    }
    componentDidUpdate(prevProps) {
        const { focusOnOption } = this.props;
        if (prevProps.focusOnOption !== focusOnOption) {
            this._markOptionAndScrollIntoViewOnMoundAndChange();
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.visible !== nextProps.visible) {
            this._markOption(NOT_HOVERED_INDEX);
        }
        if (this.props.selectedId !== nextProps.selectedId) {
            this.setState({ selectedId: nextProps.selectedId });
        }
        // make sure the same item is hovered if options changed
        if (this.state.hoveredIndex !== NOT_HOVERED_INDEX &&
            (!nextProps.options[this.state.hoveredIndex] ||
                this.props.options[this.state.hoveredIndex].id !==
                    nextProps.options[this.state.hoveredIndex].id)) {
            this._markOption(nextProps.options.findIndex(byId(this.props.options[this.state.hoveredIndex].id)));
        }
        this._markOptionByProperty(nextProps);
    }
    _focusFirstOption() {
        this._focus(this.focusableItemsIdsList[0], undefined);
    }
    // Deprecated
    _checkIfEventOnElements(e, elem) {
        let current = e.target;
        while (current.parentNode) {
            if (elem.indexOf(current) > -1) {
                return true;
            }
            current = current.parentNode;
        }
        return current !== document;
    }
    // Deprecated
    _renderTopArrow() {
        const { withArrow, visible } = this.props;
        return withArrow && visible ? (React.createElement("div", { "data-hook": DATA_HOOKS.TOP_ARROW, className: classes.arrow })) : null;
    }
    _isControlled() {
        return (typeof this.props.selectedId !== 'undefined' &&
            typeof this.props.onSelect !== 'undefined');
    }
    _scrollToSelectedOption() {
        if (this.selectedOption) {
            this.options.scrollTop = Math.max(this.selectedOption.offsetTop - this.selectedOption.offsetHeight, 0);
        }
    }
    _setSelectedOptionNode(optionNode, option) {
        if (option.id === this.state.selectedId) {
            this.selectedOption = optionNode;
        }
    }
    /** persist hover index & invoke callback from props */
    _markOption(index, options) {
        const { onOptionMarked } = this.props;
        options = options || this.props.options;
        this.setState({ hoveredIndex: index });
        onOptionMarked &&
            onOptionMarked(options[index] || null);
    }
    /**
     * get current focused option index
     **/
    _getMarkedIndex() {
        const { options } = this.props;
        const useFocusedIdIndex = this.state.focusedItemId !== DropdownLayout.NONE_SELECTED_ID;
        const useSelectedIdIndex = typeof this.state.selectedId !== 'undefined';
        let markedIndex;
        if (useFocusedIdIndex) {
            markedIndex = options.findIndex(byId(this.state.focusedItemId));
        }
        else if (useSelectedIdIndex) {
            markedIndex = options.findIndex(byId(this.state.selectedId));
        }
        else {
            markedIndex = NOT_HOVERED_INDEX;
        }
        return markedIndex;
    }
    _getNextSelectableIndex(index, step) {
        const { options } = this.props;
        let nextSelectableIndex = index;
        do {
            nextSelectableIndex = Math.abs(modulu(Math.max(nextSelectableIndex + step, -1), options.length));
        } while (!this._isSelectableOption(options[nextSelectableIndex]));
        return nextSelectableIndex;
    }
    _markNextStep(step) {
        const { options } = this.props;
        if (!options.some(this._isSelectableOption)) {
            return;
        }
        const currentIndex = this._getMarkedIndex();
        const nextIndex = this._getNextSelectableIndex(currentIndex, step);
        const nextId = this.props.options[nextIndex].id;
        this._markOptionAndScrollIntoView(nextIndex);
        this._focus(nextId, undefined);
    }
    _scrollToOption() {
        const { scrollToOption, options } = this.props;
        const optionIndex = options.findIndex((option) => option.id === scrollToOption);
        const optionNode = this.options.childNodes[optionIndex];
        if (!optionNode) {
            return;
        }
        this.options.scrollTop = Math.max(optionNode.offsetTop - optionNode.offsetHeight, 0);
    }
    _renderNode(node) {
        return node ? React.createElement("div", null, node) : null;
    }
    _convertOptionToListItemSectionBuilder({ option, idx }) {
        const { value, id, title: isTitle } = option;
        if (value === DIVIDER_OPTION_VALUE) {
            return listItemSectionBuilder({
                dataHook: OPTION_DATA_HOOKS.DIVIDER,
                id: id || idx,
                type: 'divider',
            });
        }
        if (isTitle) {
            return listItemSectionBuilder({
                dataHook: OPTION_DATA_HOOKS.TITLE,
                id,
                type: 'subheader',
                // @ts-expect-error
                title: value,
            });
        }
        return undefined;
    }
    _convertOptionToListItemActionBuilder({ option, idx }) {
        // @ts-expect-error
        const { id, value, disabled, optionTitle, title, ...rest } = option;
        return listItemActionBuilder({
            id: id !== undefined ? id : idx,
            ref: (ref) => (this.children[id] = ref),
            // @ts-expect-error
            tabIndex: id === this.state.focusedItemId && !disabled ? '0' : '-1',
            disabled,
            title: optionTitle,
            role: 'menuitem',
            ...rest,
        });
    }
    _convertCustomOptionToBuilder({ option }) {
        const { value, id, disabled, overrideOptionStyle, overrideStyle } = option;
        if (overrideStyle) {
            return {
                id,
                disabled,
                overrideStyle,
                value: () => React.createElement("div", { "data-hook": DATA_HOOKS.OPTION }, value),
            };
        }
        if (overrideOptionStyle) {
            return {
                id,
                disabled,
                overrideOptionStyle,
                value: () => React.createElement("div", { "data-hook": DATA_HOOKS.OPTION }, value),
            };
        }
        return undefined;
    }
    _convertOptionToListItemSelectBuilder({ option }) {
        const { value, id, disabled } = option;
        const { selectedId } = this.state;
        const { itemHeight, selectedHighlight } = this.props;
        return listItemSelectBuilder({
            id,
            title: React.createElement("div", { "data-hook": DATA_HOOKS.OPTION }, value),
            disabled,
            selected: id === selectedId && selectedHighlight,
            className: st(classes.selectableOption, {
                itemHeight,
                focused: this.state.focusedItemId === id,
            }),
        });
    }
    _isBuilderOption({ option }) {
        const { value } = option;
        return typeof value === 'function';
    }
    _isActionOption({ option }) {
        return option.value === ListTypeEnum.action;
    }
    _isItemSection({ option }) {
        const { value, title: isTitle } = option;
        return value === DIVIDER_OPTION_VALUE || isTitle;
    }
    _isCustomOption({ option }) {
        const { overrideOptionStyle, overrideStyle } = option;
        return overrideOptionStyle || overrideStyle;
    }
    _convertOptionToBuilder({ option, idx }) {
        if (this._isBuilderOption({ option })) {
            return option;
        }
        else if (this._isActionOption({ option })) {
            return this._convertOptionToListItemActionBuilder({ option, idx });
        }
        else if (this._isItemSection({ option })) {
            return this._convertOptionToListItemSectionBuilder({ option, idx });
        }
        else if (this._isCustomOption({ option })) {
            return this._convertCustomOptionToBuilder({ option });
        }
        else {
            return this._convertOptionToListItemSelectBuilder({ option });
        }
    }
    _renderOption({ option, idx }) {
        const builderOption = this._convertOptionToBuilder({ option, idx });
        const content = this._renderOptionContent({
            option: builderOption,
            idx,
            hasLink: !!option.linkTo,
        });
        const isActionItem = this.props.listType === ListTypeEnum.action;
        return option.linkTo ? (React.createElement("a", { className: classes.linkItem, key: idx, "data-hook": DATA_HOOKS.LINK_ITEM, href: option.linkTo, role: isActionItem ? undefined : 'option', "aria-selected": isActionItem || option.disabled
                ? undefined
                : option.id === this.state.selectedId, "aria-hidden": option.disabled }, content)) : (content);
    }
    _renderOptionContent(arg) {
        const { option, idx, hasLink } = arg;
        const { itemHeight, selectedHighlight, listType } = this.props;
        const { selectedId, focusedItemId, hoveredIndex } = this.state;
        const { id, disabled, overrideStyle, overrideOptionStyle } = option;
        const optionState = {
            selected: id === selectedId,
            focused: id === focusedItemId,
            hovered: idx === hoveredIndex,
            disabled,
        };
        if (!disabled) {
            this.focusableItemsIdsList = [...this.focusableItemsIdsList, id];
        }
        const isActionItem = listType === ListTypeEnum.action;
        return (React.createElement("div", { "aria-selected": hasLink || isActionItem || disabled ? undefined : optionState.focused, "aria-hidden": disabled, role: hasLink || isActionItem ? undefined : 'option', ...this._getItemDataAttr({ ...optionState }), className: overrideOptionStyle
                ? null
                : st(classes.option, {
                    ...optionState,
                    selected: optionState.selected && selectedHighlight,
                    itemHeight,
                    overrideStyle,
                }), ref: (node) => this._setSelectedOptionNode(node, option), onClick: !disabled ? (e) => this._onSelect(idx, e) : null, key: idx, onMouseEnter: () => this._onMouseEnter(idx), onMouseLeave: this._onMouseLeave, "data-hook": `dropdown-item-${id}`, onKeyDown: (e) => this._onActionListKeyDown(e, id) }, option.value(optionState)));
    }
    _markOptionByProperty(props) {
        if (this.state.hoveredIndex === NOT_HOVERED_INDEX && props.markedOption) {
            const selectableOptions = props.options.filter(this._isSelectableOption);
            if (selectableOptions.length) {
                const idToMark = props.markedOption === true
                    ? selectableOptions[0].id
                    : props.markedOption;
                const indexToMark = props.options.findIndex(byId(idToMark));
                this._markOption(indexToMark, props.options);
            }
        }
    }
    _isSelectableOption(option) {
        return (option &&
            option.value !== DIVIDER_OPTION_VALUE &&
            !option.disabled &&
            !option.title);
    }
    _renderOptions() {
        this.focusableItemsIdsList = [];
        this._saveOnClicks();
        return this.props.options.map((option, idx) => this._renderOption({ option, idx }));
    }
    render() {
        const { className, visible, dropDirectionUp, tabIndex, onMouseEnter, onMouseLeave, onMouseDown, fixedHeader, withArrow, fixedFooter, inContainer, overflow, maxHeightPixels, minWidthPixels, infiniteScroll, dataHook, listType, } = this.props;
        const renderedOptions = this._renderOptions();
        return (React.createElement("div", { "data-list-type": listType, "data-hook": dataHook, className: st(classes.root, {
                visible,
                withArrow,
                // @ts-expect-error TODO: JB: stylable types
                direction: dropDirectionUp
                    ? DROPDOWN_LAYOUT_DIRECTIONS.UP
                    : DROPDOWN_LAYOUT_DIRECTIONS.DOWN,
                containerStyles: !inContainer,
            }, className), tabIndex: tabIndex, onKeyDown: this._onSelectListKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseDown: onMouseDown, ref: this.containerRef },
            React.createElement("div", { ...this._getDataAttributes(), className: classes.contentContainer, style: {
                    overflow,
                    maxHeight: getUnit(maxHeightPixels),
                    minWidth: getUnit(minWidthPixels),
                } },
                this._renderNode(fixedHeader),
                React.createElement("div", { className: classes.options, style: {
                        maxHeight: getUnit(parseInt(`${maxHeightPixels}`, 10) - 35),
                        overflow,
                    }, ref: (_options) => (this.options = _options), "data-hook": DATA_HOOKS.DROPDOWN_LAYOUT_OPTIONS, role: listType === ListTypeEnum.select ? 'listbox' : 'menu' }, infiniteScroll
                    ? this._wrapWithInfiniteScroll(renderedOptions)
                    : renderedOptions),
                this._renderNode(fixedFooter)),
            this._renderTopArrow()));
    }
}
const optionPropTypes = PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    value: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.func])
        .isRequired,
    disabled: PropTypes.bool,
    /** @deprecated*/
    overrideStyle: PropTypes.bool,
    /** @deprecated*/
    title: PropTypes.bool,
    overrideOptionStyle: PropTypes.bool,
    /* the string displayed within the input when the option is selected */
    label: PropTypes.string,
});
export const optionValidator = (props, propName, componentName) => {
    const option = props[propName];
    // Notice: We don't use Proptypes.oneOf() to check for either option OR divider, because then the failure message would be less informative.
    if (typeof option === 'object' && option.value === DIVIDER_OPTION_VALUE) {
        return;
    }
    const optionError = PropTypes.checkPropTypes({ option: optionPropTypes }, { option }, 'option', componentName);
    // @ts-expect-error TODO: JB: nothing to do, optionError should be always undefined
    if (optionError) {
        return optionError;
    }
    return undefined;
};
DropdownLayout.propTypes = {
    className: PropTypes.string,
    dropDirectionUp: PropTypes.bool,
    focusOnSelectedOption: PropTypes.bool,
    onClose: PropTypes.func,
    onSelect: PropTypes.func,
    onOptionMarked: PropTypes.func,
    // @ts-expect-error TODO: JB: propTypes
    overflow: PropTypes.string,
    visible: PropTypes.bool,
    options: PropTypes.arrayOf(optionValidator),
    selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tabIndex: PropTypes.number,
    onClickOutside: PropTypes.func,
    fixedHeader: PropTypes.node,
    fixedFooter: PropTypes.node,
    maxHeightPixels: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    minWidthPixels: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    withArrow: PropTypes.bool,
    closeOnSelect: PropTypes.bool,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    itemHeight: PropTypes.oneOf(['small', 'big']),
    selectedHighlight: PropTypes.bool,
    inContainer: PropTypes.bool,
    infiniteScroll: PropTypes.bool,
    loadMore: PropTypes.func,
    hasMore: PropTypes.bool,
    markedOption: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string,
        PropTypes.number,
    ]),
    focusOnOption: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    scrollToOption: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    listType: PropTypes.oneOf([ListTypeEnum.action, ListTypeEnum.select]),
    autoFocus: PropTypes.bool,
};
DropdownLayout.defaultProps = {
    options: [],
    tabIndex: 0,
    maxHeightPixels: 260,
    closeOnSelect: true,
    itemHeight: 'small',
    selectedHighlight: true,
    inContainer: false,
    infiniteScroll: false,
    loadMore: null,
    hasMore: false,
    markedOption: false,
    overflow: 'auto',
    listType: ListTypeEnum.select,
};
DropdownLayout.displayName = 'DropdownLayout';
DropdownLayout.NONE_SELECTED_ID =
    'unsafe_none_selected_option_id_because_id_is_optional_on_divider_option';
export default DropdownLayout;
//# sourceMappingURL=DropdownLayout.js.map